export enum OrderStatuses {
  Capturing,
  FinishedCapturing,
  Waiting,
  NotFound,
  Aborted,
}
